import { Button } from '@mui/material'
import * as React from 'react'
import DialogComponent from '../DialogComponent/DialogComponent'
import { AnalyticService } from '../../lib/analytics/analyticService'
import HubspotSupportForm from './HubspotSupportForm'

const HubspotSupportFormDialogButton = (props: {
  buttonText: string
  buttonVariant?: 'text' | 'contained' | 'outlined'
  buttonStyle?: React.CSSProperties
}) => {
  const [openDialog, setOpenDialog] = React.useState(false)

  const handleToggleDialog = () => {
    if (!openDialog) {
      AnalyticService.onAdminHubspotDialogOpened()
    }
    setOpenDialog(!openDialog)
  }

  return (
    <>
      <Button
        onClick={handleToggleDialog}
        variant={props.buttonVariant || 'text'}
        color={'primary'}
        disableElevation={true}
        style={props.buttonStyle}
      >
        {props.buttonText.length ? props.buttonText : 'Contact us'}
      </Button>
      <DialogComponent
        contentPadding="0px"
        title="Having Issues? Let us know"
        fullScreen={false}
        onRequestClose={handleToggleDialog}
        open={openDialog}
        content={<HubspotSupportForm />}
      />
    </>
  )
}

export default HubspotSupportFormDialogButton
